export const idx_data_hole_depth = [];

idx_data_hole_depth.push({
  decimal: 0,
  fraction: '---',
});

idx_data_hole_depth.push({
  decimal: 0.125,
  fraction: '1/4',
});

idx_data_hole_depth.push({
  decimal: 0.5,
  fraction: '1/2',});

idx_data_hole_depth.push({
  decimal: 0.75,
  fraction: '3/4',
});

idx_data_hole_depth.push({
  decimal: 1,
  fraction: '1',
});

idx_data_hole_depth.push({
  decimal: 1.25,
  fraction: '1 1/4',
});

idx_data_hole_depth.push({
  decimal: 1.5,
  fraction: '1 1/2',
});

idx_data_hole_depth.push({
  decimal: 1.75,
  fraction: '1 3/4',
});

idx_data_hole_depth.push({
  decimal: 2,
  fraction: '2',
});

idx_data_hole_depth.push({
  decimal: 2.25,
  fraction: '2 1/4',
});

idx_data_hole_depth.push({
  decimal: 2.5,
  fraction: '2 1/2',
});

idx_data_hole_depth.push({
  decimal: 2.75,
  fraction: '2 3/4',
});

idx_data_hole_depth.push({
  decimal: 3,
  fraction: '3',
});

idx_data_hole_depth.push({
  decimal: 3.25,
  fraction: '3 1/4',
});

idx_data_hole_depth.push({
  decimal: 3.5,
  fraction: '3 1/2',
});

idx_data_hole_depth.push({
  decimal: 3.75,
  fraction: '3 3/4',
});

idx_data_hole_depth.push({
  decimal: 4,
  fraction: '4',
});

idx_data_hole_depth.push({
  decimal: 4.25,
  fraction: '4 1/4',
});
